export default "__VITE_ASSET__BfhOB_0X__"